<style scoped>
/deep/.el-input-number__decrease {
  display: none;
}
/deep/.el-input-number__increase {
  display: none;
}
/deep/ .el-input-number .el-input__inner {
  text-align: left;
  padding-left: 15px;
}
.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;
}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}

.pdt100 {
  padding-bottom: 100px !important;
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.header .back {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.import-title {
  text-align: left;
  background: #fff;
  padding: 10px 16px;
  font-size: 16px;
  position: relative;
}

.empty-tooltip {
  background: #fff;
  font-size: 16px;
  padding: 25px 0;
}

.import-title.second {
  margin-top: 4px;
}

.header .title {
  text-align: center;
  flex: 1;
}

.customer-information {
  background: #fff;
  padding-bottom: 15px;
}

.customer-information .sub-title {
  text-align: left;
  font-size: 14px;
  line-height: 28px;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
}

.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}

.sub-operate-add2 {
  color: #4fa1a4;
  font-size: 14px;
  margin-left: 14px;
  cursor: pointer;
  position: absolute;
  right: 35px;
  top: 10px;
  text-align: center;
}

.sub-operate-del {
  font-size: 14px;
  color: #4fa1a4;
  cursor: pointer;
  text-align: center;
  margin: 0 20px;
}

.customer-information .cols {
  background: #fff;
  display: flex;
  padding: 4px 16px;
  padding-left: 20px;
}

.customer-information .col-itms {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.customer-information .col-itms .title {
  width: 120px;
  text-align: right;
  margin-right: 16px;
}

.customer-information .col-itms.second {
  margin-left: 170px;
}

.customer-information .col-itms .title span {
  color: red;
}

.import-new-wrap {
  padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
  text-align: left;
  padding-left: 10px;
  color: #666;
  font-size: 12px;
}

.import-new-wrap .col-itms {
  align-items: baseline;
}

.operte-btns {
  background: #fff;
  margin-top: 4px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}
.file-operate {
  display: flex;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.bank-content {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.bank-info {
  color: #a7a7a7;
}
</style>

<template>
  <div>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading" v-show="!showDialogBox">
      <div class="header">
        <div class="back" @click="$router.go(-1)">返回</div>
        <div class="title">下游发票信息管理</div>
      </div>
      <div class="import-title">
        <!-- <div class="cost-title-list">
          <span class="cost-title-list-line"></span>
          <span class="cost-title-list-txt">基础信息</span>
        </div> -->
        <span class="cost-title-list-txt">基础信息</span>
      </div>
      <div class="customer-information">
        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>开票日期</div>
            <el-date-picker
              size="small"
              :disabled="isDisabled"
              class="w300"
              type="date"
              placeholder="请选择"
              v-model="form.invoiceDate"
            ></el-date-picker>
          </div>
          <div class="col-itms second">
            <div class="title"><span>*</span>业务类型</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              v-model="form.bizTypeGuid"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option
                v-for="item in getCodeListByKey('合同内容分类')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>税率(%)</div>
            <el-input
              size="small"
              :disabled="isDisabled"
              class="w300"
              oninput="value=value.replace(/[^\d.]/g, '')"
              @blur="taxRateCheck"
              maxlength="5"
              placeholder="请填写"
              v-model="form.taxRate"
            ></el-input>
          </div>
          <div class="col-itms second">
            <div class="title"><span>*</span>开票金额(元)</div>
            <el-input-number
              size="small"
              :disabled="isDisabled"
              class="w300"
              :precision="isDisabled ? 4 : 2"
              :step="0.1"
              :max="1000000000"
              placeholder="请填写"
              v-model="form.invoiceAccount"
            ></el-input-number>
          </div>
        </div>

        <div class="cols">
          <div class="col-itms">
            <!-- 开票方(代征代缴公司) -->
            <div class="title"><span>*</span>开票方</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              @change="invoiceNameChange"
              v-model="form.invoiceTenantGuid"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option v-for="item in invoiceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
              </el-option>
            </el-select>
          </div>
          <!-- 开票方(服务商) -->
          <div class="col-itms second">
            <div class="title"><span>*</span>收票方</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              @change="receiveNameChange"
              v-model="form.receiveTenantGuid"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option v-for="item in receiveTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>付款状态</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              v-model="form.paymentStatus"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option v-for="item in paymentStatusList" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="col-itms second">
            <div class="title"><span>*</span>对应合同名称</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              @focus="contractNameFoucs"
              @change="contractNameChange"
              v-model="form.contractNo"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option
                v-for="item in contractList"
                :key="item.contractCode"
                :label="item.contractName"
                :value="item.contractCode"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>对应款项</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              v-model="form.counterpartGuid"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option
                v-for="item in getCodeListByKey('对应款项')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-itms second">
            <div class="title"><span>*</span>对应合同编号</div>
            <el-input size="small" class="w300" disabled v-model="form.contractNo" placeholder="勾选合同后带出"></el-input>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>发票类型</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              v-model="form.invoiceOptions"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option
                v-for="item in getCodeListByKey('发票选项')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-itms second">
            <div class="title"><span>*</span>发票类目</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              v-model="form.invoiceCategory"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option
                v-for="item in getCodeListByKey('发票类目')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>任务大类</div>
            <el-select
              size="small"
              :disabled="isDisabled"
              v-model="form.taskType"
              placeholder="请选择"
              filterable
              class="w300"
            >
              <el-option
                v-for="item in getCodeListByKey('任务大类')"
                :key="item.value"
                :label="item.text"
                :value="item.text"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="import-new-wrap">
          <div class="cols">
            <div class="col-itms">
              <div class="title"><span>*</span>上传发票</div>
              <template v-if="!isDisabled">
                <el-upload
                  :before-upload="beforeAvatarUpload"
                  size="small"
                  :disabled="isDisabled"
                  class="upload-demo t-left"
                  action="#"
                  ref="createProject"
                  :file-list="invoiceAttach"
                  accept=".jpg,.png,.jpeg,.pdf,.zip,.ofd"
                  :auto-upload="true"
                  :http-request="changeMainFile"
                  :limit="5"
                  :on-exceed="handleExceed"
                >
                  <div class="file-operate" slot="file" slot-scope="{ file }">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-preview" @click="onPreview(file)">查看</div>
                    <div v-if="!isDisabled" class="file-preview" @click="handleMainRemove(file)">删除</div>
                    <div class="file-preview" @click="onDownload(file)">下载</div>
                  </div>
                  <div class="import-btn-tips">
                    <el-button size="mini" icon="el-icon-my-import" type="importNew">导入文件</el-button>
                    <div class="import-step-tip">支持上传jpg、png、jpeg、pdf、zip、ofd文件，单个文件大小≤{{ fileSize }}M</div>
                  </div>
                </el-upload>
              </template>
              <template v-else>
                <div v-if="invoiceAttach && invoiceAttach.length">
                  <div class="file-operate" style="color: #606266" v-for="item in invoiceAttach" :key="item.path">
                    <span class="file-name">{{ item.name }}</span>
                    <span class="file-preview" @click="onPreview(item)">查看</span>
                    <span v-if="!isDisabled" class="file-preview" @click="handleMainRemove(item)">删除</span>
                    <span class="file-preview" @click="onDownload(item)">下载</span>
                  </div>
                </div>
                <div v-else>{{ '-' }}</div>
              </template>
            </div>
          </div>
        </div>
        <div class="import-new-wrap">
          <div class="cols">
            <div class="col-itms">
              <div class="title"><span v-show="showCheckPayment">*</span>上传结算单</div>
              <template v-if="!isDisabled">
                <el-upload
                  :before-upload="beforeAvatarUpload"
                  size="small"
                  :disabled="isDisabled"
                  class="upload-demo t-left"
                  action="#"
                  ref="createProjectII"
                  :file-list="settlementAttach"
                  accept=".jpg,.png,.jpeg,.pdf,.zip"
                  :auto-upload="true"
                  :http-request="changeSubFile"
                  :limit="5"
                  :on-exceed="handleExceed"
                >
                  <div class="file-operate" slot="file" slot-scope="{ file }">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-preview" @click="onPreview(file)">查看</div>
                    <div class="file-preview" @click="onDownload(file)">下载</div>
                    <div v-if="!isDisabled" class="file-preview" @click="handleSubRemove(file)">删除</div>
                  </div>
                  <div class="import-btn-tips">
                    <el-button size="mini" icon="el-icon-my-import" type="importNew">导入文件</el-button>
                    <div class="import-step-tip">支持上传jpg、png、jpeg、pdf、zip文件，单个文件大小≤{{ fileSize }}M</div>
                  </div>
                </el-upload>
              </template>
              <template v-else>
                <div v-if="settlementAttach && settlementAttach.length">
                  <div class="file-operate" style="color: #606266" v-for="item in settlementAttach" :key="item.path">
                    <span class="file-name">{{ item.name }}</span>
                    <span class="file-preview" @click="onPreview(item)">查看</span>
                    <span v-if="!isDisabled" class="file-preview" @click="handleMainRemove(item)">删除</span>
                    <span class="file-preview" @click="onDownload(item)">下载</span>
                  </div>
                </div>
                <div v-else>{{ '-' }}</div>
              </template>
            </div>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title">备注说明</div>
            <el-input
              size="small"
              :disabled="isDisabled"
              type="textarea"
              class="w300"
              maxlength="200"
              placeholder="请填写"
              v-model="form.remark"
              show-word-limit
            ></el-input>
          </div>
        </div>
      </div>
      <div class="import-title second">
        <span class="cost-title-list-txt">关联付款信息</span>
        <div v-if="!isDisabled" class="sub-operate-add2" @click="addReceiveItem">新增</div>
      </div>
      <template v-if="form.invoices && Array.isArray(form.invoices)">
        <div class="customer-information" v-for="(invoicesItem, index) in form.invoices" :key="index">
          <div class="sub-title">
            付款时间与付款金额{{ index + 1 }}
            <div v-if="!isDisabled" class="sub-operate-del" @click="delReceiveItem(index)">删除</div>
          </div>
          <div class="cols">
            <div class="col-itms">
              <div class="title"><span>*</span>付款信息</div>
              <el-input
                size="small"
                :disabled="isDisabled"
                class="w300"
                @focus="showCollectionList(index)"
                @input="invoiceNameInput(index)"
                v-model="invoicesItem.label"
                placeholder="请输入内容"
              >
                <i class="el-icon-arrow-down el-input__icon" slot="suffix" @click="showCollectionList(index)"> </i>
              </el-input>
              <div v-if="!isDisabled" class="sub-operate-add" @click="addCollectionInfo(index)">去添加</div>
            </div>
          </div>
          <!-- 收款银行信息 -->
          <div class="cols" v-if="invoicesItem.receiveAmount">
            <div class="col-itms">
              <div class="title"></div>
              <div class="bank-content w300">
                <div><span class="bank-info">收款金额(元)：</span>{{ invoicesItem.receiveAmount | numDigit }}</div>
                <div>
                  <span class="bank-info">大写金额(圆)：</span>{{ (invoicesItem.receiveAmount || '') | smallToBig }}
                </div>
                <div>
                  <span class="bank-info">是否垫资款：</span>{{ invoicesItem.isCapitalAdvances | getIsInvoiceFirst }}
                </div>
              </div>
            </div>
          </div>
          <div class="cols">
            <div class="col-itms">
              <div class="title"><span>*</span>发票号码</div>
              <el-input
                size="small"
                :disabled="isDisabled"
                type="textarea"
                class="w300"
                maxlength="500"
                show-word-limit
                placeholder="可输入多个发票号码，用顿号隔开"
                v-model="invoicesItem.invoiceNo"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="customer-information">
          <div class="cols">
            <div class="col-itms">
              <div class="title"><span></span>合计</div>
              <span >
                {{ getSumAmount(form.invoices)| numDigit }} 元
              </span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="empty-tooltip">{{ '暂无收款信息' }}</div>
      </template>
      <div class="operte-btns">
        <div class="btn cancel" @click="$router.go(-1)">取消</div>

        <div v-if="!isDisabled" class="btn submit" @click="saveReq">确定</div>
      </div>
    </div>
    <!-- 新增收款信息 -->
    <AddCollectionDialogBox
      ref="AddCollectionDialogBox"
      :paramCollection="paramCollection"
      :invoiceTenantList="invoiceTenantList"
      :receiveTenantList="receiveTenantList"
      @getCollectionInfo="getCollectionInfo"
      @closedDialogBox="closedDialogBox"
    >
    </AddCollectionDialogBox>
    <CollectionListDialogBox
      ref="CollectionListDialogBox"
      :paramCollection="paramCollection"
      @getCollectionInfo="getCollectionInfo"
    ></CollectionListDialogBox>
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import AddCollectionDialogBox from './components/addCollectionDialogBox';
import CollectionListDialogBox from './components/collectionListDialogBox';
export default {
  components: {
    AddCollectionDialogBox,
    CollectionListDialogBox,
  },
  data() {
    return {
      fullscreenLoading: false,

      invoiceTenantList: [], //开票方list

      receiveTenantList: [], //接收方list

      paymentStatusList: [
        //付款状态list
        {
          text: '待付款',
          value: 'N',
        },
        {
          text: '已付款',
          value: 'Y',
        },
      ],
      contractList: [], //合同list
      guid: '',
      form: {
        invoiceOptions: '',
        invoiceCategory: '',
        invoiceDate: '', //开票日期
        bizTypeGuid: '', //业务类型
        taxRate: '', //税率
        invoiceAccount: undefined, //开票金额
        invoiceTenantName: '',
        invoiceTenantGuid: '', //开票方
        receiveTenantName: '',
        receiveTenantGuid: '', //收票方
        paymentStatus: '', //付款状态
        contractNo: '', //合同编号
        contractName: '',
        counterpartGuid: '', //对应款项
        remark: '',
        invoices: [],
      },
      invoiceAttach: [],
      settlementAttach: [],
      fileSize: serverConfig.FILE_SIZE,
      paramCollection: {
        // 新增收款信息传递参数
        streamType: '2',
        index: '', // 款项信息的索引
        title: '新增下游付款款信息',
        operationType: '关联新增方式',
        invoiceTenantGuid: '', // 开票方-收款方(代征代缴公司)唯一标识
        invoiceTenantName: '', // 开票方(代征代缴公司)name
        receiveTenantGuid: '', // 收票方-支付方(服务商)唯一标识
        receiveTenantName: '', // 收票方(服务商)name
        counterpartGuid: '', //对应款项
      },
      showDialogBox: false, // 显示收款信息表单
      restaurants: [],
    };
  },
  watch: {},
  computed: {
    showCheckPayment() {
      // !上传付款通知书校验触发标识
      return this.form.bizTypeGuid === '1' ? true : false;
    },
    isDisabled() {
      return this.$route.query.operationMode === 'look';
    },
  },
  created() {
    this.getDetail();
    this.getInvoiceTenantList();
    this.getReceiveTenantList();
  },
  methods: {
    getSumAmount(list, type) {
      let sum = 0;
      list.forEach((item) => {
        sum += Math.round(item.receiveAmount * 100) / 100 ;
      });
      return sum;
    },
    getDetail() {
      let self = this;
      let query = {
        guid: this.$route.query.guid,
      };
      if (!this.$route.query.guid) return;
      self.api.get(`/${serverConfig.msCustomerService}/downstream-invoice-info/detail`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let form = res.data.data;
          let { invoices } = form;
          if (invoices && Array.isArray(invoices)) {
            this.getCollectionInfoLabel(invoices);
          }
          //文件
          form.invoiceAttach = JSON.parse(form.invoiceAttach);
          form.settlementAttach = JSON.parse(form.settlementAttach);
          form.invoiceAttach &&
            form.invoiceAttach.forEach((item) => {
              this.invoiceAttach.push({
                name: item.fileName,
                path: item.path,
              });
            });
          form.settlementAttach &&
            form.settlementAttach.forEach((item) => {
              this.settlementAttach.push({
                name: item.fileName,
                path: item.path,
              });
            });
          this.form = form;
          this.guid = form.guid;

          this.getContractList(); // todo获取双方guid后查询对应合同
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取开票方-收款方(代征代缴公司)
    getInvoiceTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901', '9903', '9904'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.invoiceTenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //开票方change
    invoiceNameChange(val) {
      const filterItem = this.invoiceTenantList.filter((item) => item.guid == val);
      this.form.invoiceTenantName = filterItem[0].tenantName;
    },
    //获取收票方-支付方(服务商)
    getReceiveTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901'],
        relType: '123', // 写死 支持选自己
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.receiveTenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //收票方change
    receiveNameChange(val) {
      const filterItem = this.receiveTenantList.filter((item) => item.guid == val);
      this.form.receiveTenantName = filterItem[0].tenantName;
    },
    //获取合同
    getContractList() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        // staffGuid: userinfo.staffGuid,
        approveState: 'Y',
        tenantGuid: this.form.receiveTenantGuid, // 甲方(收票)企业
        serviceTenantGuid: this.form.invoiceTenantGuid, // 乙方(开票)企业
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/contract/list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.contractList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //合同change
    contractNameChange(val) {
      const filterItem = this.contractList.filter((item) => item.contractCode == val);
      this.form.contractName = filterItem[0].contractName;
    },
    // 合同fouce
    contractNameFoucs() {
      if (!this.form.receiveTenantGuid || !this.form.invoiceTenantGuid ) {
        this.$message({
          message: '请勾选开票方和收票方',
          type: 'warning',
        });
        return;
      }
      this.getContractList();
    },
    addReceiveItem() {
      if (this.form.invoices) {
        this.form.invoices.push({
          invoiceNo: '',
          receiveDate: '',
          receiveAmount: '',
          isCapitalAdvances: '',
          selectItem: {},
        });
      } else {
        this.form.invoices = [];
        this.form.invoices.push({
          invoiceNo: '',
          receiveDate: '',
          receiveAmount: '',
          isCapitalAdvances: '',
          selectItem: {},
        });
      }
    },
    delReceiveItem(index) {
      let self = this;
      self
        .$confirm('确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.form.invoices.splice(index, 1);
        });
    },
    //提交申请
    saveReq() {
      if (!this.checkForm()) return;
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let form = this.form;
      form.createUserName = userInfo.staffName;
      let invoiceAttach = this.invoiceAttach;
      let settlementAttach = this.settlementAttach;
      let reqUrl;
      invoiceAttach.forEach((item) => {
        item.fileName = item.name;
      });
      settlementAttach.forEach((item) => {
        item.fileName = item.name;
      });
      form.settlementAttach = settlementAttach.length ? settlementAttach : null;
      form.invoiceAttach = invoiceAttach;
      if (this.guid) {
        reqUrl = `/${serverConfig.msCustomerService}/downstream-invoice-info/update`;
        form.guid = this.guid;
      } else {
        reqUrl = `/${serverConfig.msCustomerService}/downstream-invoice-info/add`;
        form.guid = null;
      }
      this.fullscreenLoading = true;
      this.api.postJson(reqUrl, form).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message({
            message: '新增成功',
            type: 'success',
          });
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    onPreview(file) {
      var fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf' || fileSuffix === 'zip') {
        return window.open(file.path, file.name);
      }
      if (fileSuffix=='ofd') {
        return window.open("https://ofd.xdocin.com/view?src=" + encodeURIComponent(file.path)); 
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    // 上传文件
    changeMainFile(file) {
      let isLt5M = file.file.size / 1024 / 1024 < this.fileSize;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过 ${this.fileSize}MB`);
        this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      this.fullscreenLoading = true;
      this.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.invoiceAttach.push({
              name: file.file.name,
              path: res.data.data.data,
            });
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            this.$message.error('上传失败!');
          }
        })
        .catch(() => {
          this.$message('上传失败！');
        });
    },
    handleMainRemove(file) {
      this.invoiceAttach.forEach((item, index) => {
        if (item.path == file.path) {
          this.invoiceAttach.splice(index, 1);
        }
      });
    },
    changeSubFile(file) {
      let isLt5M = file.file.size / 1024 / 1024 < this.fileSize;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${this.fileSize}MB`);
        this.$refs.createProjectII.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      this.fullscreenLoading = true;
      this.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.settlementAttach.push({
              name: file.file.name,
              path: res.data.data.data,
            });
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            this.settlementAttach = [];
            this.$message.error('上传失败!');
          }
        })
        .catch(() => {
          this.$message('上传失败！');
        });
    },
    handleSubRemove(file) {
      this.settlementAttach.forEach((item, index) => {
        if (item.path == file.path) {
          this.settlementAttach.splice(index, 1);
        }
      });
    },
    handleExceed(files, fileList) {
      this.fileList = [];
      this.$message.warning('当前限制选择 5 个文件');
    },
    taxRateCheck() {
      if (this.form.taxRate > 100 || this.form.taxRate < 0) {
        this.$message.warning('请输入0-100的数值');
        this.form.taxRate = '';
      }
    },
    checkForm() {
      if (!this.form.invoiceDate) {
        this.$message.error('开票日期不能为空');
        return false;
      }
      if (!this.form.bizTypeGuid) {
        this.$message.error('业务类型不能为空');
        return false;
      }
      if (!this.form.taxRate) {
        this.$message.error('税率不能为空');
        return false;
      }
      if (!this.form.invoiceAccount) {
        this.$message.error('开票金额不能为空');
        return false;
      }
      if (!this.form.invoiceTenantGuid) {
        this.$message.error('开票方不能为空');
        return false;
      }
      if (!this.form.receiveTenantGuid) {
        this.$message.error('收票方不能为空');
        return false;
      }
      if (!this.form.paymentStatus) {
        this.$message.error('付款状态不能为空');
        return false;
      }
      if (!this.form.contractNo) {
        this.$message.error('合同名称不能为空');
        return false;
      }
      if (!this.form.counterpartGuid) {
        this.$message.error('对应款项不能为空');
        return false;
      }

      if (!this.form.invoiceOptions) {
        this.$message.error('发票类型不能为空');
        return false;
      }

      if (!this.form.invoiceCategory) {
        this.$message.error('发票类目不能为空');
        return false;
      }
      if (!this.form.taskType) {
        this.$message.error('任务大类不能为空');
        return false;
      }

      if (!this.invoiceAttach.length) {
        this.$message.error('发票不能为空');
        return false;
      }
      if (this.form.bizTypeGuid === '1') {
        if (!this.settlementAttach.length) {
          this.$message.error('付款通知书不能为空');
          return false;
        }
      }
      try {
        this.form.invoices &&
          this.form.invoices.forEach((item) => {
            if (!item.receiveDate) {
              throw new Error('付款信息不能为空');
            }
            if (!item.receiveAmount) {
              throw new Error('付款信息不能为空');
            }
            if (!item.invoiceNo) {
              throw new Error('发票号码不能为空');
            }
          });
      } catch (e) {
        this.$message.error(e.message);
        return false;
      }

      return true;
    },
    getCorrespondItemName(value) {
      return (
        this.getCodeListByKey('对应款项').find((item) => item.value === value) &&
        this.getCodeListByKey('对应款项').find((item) => item.value === value).text
      );
    },
    getCollectionInfoLabel(invoices) {
      // 设置收款内容label
      if (invoices && Array.isArray(invoices)) {
        invoices.forEach((item) => {
          if (item.correspondItem && item.receiveDate) {
            item.label = `${this.getCorrespondItemName(item.correspondItem) || ''}-${item.receiveDate}`;
            item.originalLabel = `${this.getCorrespondItemName(item.correspondItem) || ''}-${item.receiveDate}`;
          }
        });
      }
    },
    // 去添加收款信息
    addCollectionInfo(index) {
      if (!this.form.receiveTenantGuid || !this.form.invoiceTenantGuid||!this.form.counterpartGuid) {
        this.$message({
          message: '请勾选开票方和收票方及对应款项',
          type: 'warning',
        });
        return;
      }
      this.getContractList();
      let { form } = this;
      this.showDialogBox = true;
      this.$refs.AddCollectionDialogBox.outerVisible = true;
      this.paramCollection.index = index; // 对应编辑的索引
      this.paramCollection.invoiceTenantGuid = form.invoiceTenantGuid; // 开票方（收款方）唯一标识
      this.paramCollection.invoiceTenantName = this.findName(form.invoiceTenantGuid, this.invoiceTenantList) || '';
      this.paramCollection.receiveTenantGuid = form.receiveTenantGuid; // 收票方（支付方）唯一标识
      this.paramCollection.receiveTenantName = this.findName(form.receiveTenantGuid, this.receiveTenantList) || '';
      this.paramCollection.counterpartGuid = form.counterpartGuid;
    },
    findName(guid, list) {
      let itemObj = list.find((item) => item.guid === guid);
      return itemObj && itemObj.tenantName;
    },
    // 打开收款信息列表
    showCollectionList(index) {
      let { form } = this;
      this.paramCollection.index = index;
      this.$root.$emit('openCollectionList', {
        streamType: '2',
        payTenantGuid: form.receiveTenantGuid,
        receiveTenantGuid: form.invoiceTenantGuid,
      });
    },
    closedDialogBox(val) {
      if (val === 'closed') {
        this.showDialogBox = false;
      }
    },
    // 防止修改
    invoiceNameInput(index) {
      let { form } = this;
      let { invoices } = form;
      let item = invoices.find((iten, i) => i === index);
      item.label = item.originalLabel;
    },
    // 获取添加的收款信息
    getCollectionInfo(val) {
      let { paramCollection } = this;
      let { form } = this;
      let invoicesItem = form.invoices[paramCollection.index];
      invoicesItem.guid = val.guid;
      invoicesItem.accountType = val.accountType;
      invoicesItem.bankAccount = val.bankAccount;
      invoicesItem.bankName = val.bankName;
      invoicesItem.correspondItem = val.correspondItem;
      invoicesItem.isCapitalAdvances = val.isCapitalAdvances;
      invoicesItem.payTenantGuid = val.payTenantGuid;
      invoicesItem.payTenantName = val.payTenantName;
      invoicesItem.receiveAmount = val.receiveAmount;
      invoicesItem.receiveDate = val.receiveDate;
      invoicesItem.receiveTenantGuid = val.receiveTenantGuid;
      invoicesItem.receiveTenantName = val.receiveTenantName;
      invoicesItem.label = `${this.getCorrespondItemName(invoicesItem.correspondItem) || ''}-${
        invoicesItem.receiveDate
      }`;
      invoicesItem.originalLabel = `${this.getCorrespondItemName(invoicesItem.correspondItem) || ''}-${
        invoicesItem.receiveDate
      }`;
    },
    beforeAvatarUpload(file) {
      let typeObj = {
        jpg:'jpg',
        png:'png',
        jpeg:'jpeg',
        pdf:'pdf',
        zip:'zip',
        ofd:'ofd'
      }
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = typeObj[testmsg] && typeObj[testmsg] === testmsg ? true: false;
      if (!extension ) {
        this.$message({
          message: `上传文件只能是${Object.keys(typeObj).join('、')}格式!`,
          type: "warning",
        });
      }
      return extension;
    }
  },
};
</script>
